export const translations = {
  mn: {
    nav: {
      home: "Нүүр",
      jobs: "Ажлын зар",
      templates: "Загварууд",
      browseTemplates: "Загваруудыг үзэх",
      about: "Бидний тухай",
      contact: "Холбоо барих",
      mainSite: "Үндсэн сайт",
      aiChat: "AI Чат",
      examCoach: "ЭЕШ Бэлтгэл",
      geeProgress: "ЭЕШ Ахиц",
    },
    seller: {
      dashboard: {
        title: "Худалдагчийн самбар",
        welcome: "Тавтай морил",
        uploadTemplate: "Шинэ загвар байршуулах",
        salesLast30Days: "Сүүлийн 30 хоногийн борлуулалт",
        availableBalance: "Боломжтой үлдэгдэл",
        pendingPayouts: "Хүлээгдэж буй төлбөр",
        totalSales: "Нийт борлуулалт",
        recentOrders: "Сүүлийн захиалгууд",
        noOrders: "Одоогоор захиалга алга",
        paid: "Төлсөн",
        unpaid: "Төлөөгүй",
        requestWithdrawal: "Татан авалт хүсэх"
      },
      onboard: {
        title: "Худалдагч болох",
        description: "Өөрийн загваруудыг борлуулж эхлэхийн тулд дараах мэдээллийг оруулна уу",
        displayName: "Дэлгэцийн нэр",
        displayNameHint: "Энэ нэр таны загваруудад харагдах болно",
        bankInfo: "Банкны мэдээлэл",
        bankName: "Банкны нэр",
        accountHolder: "Данс эзэмшигчийн нэр",
        accountNumber: "Дансны дугаар",
        swiftCode: "SWIFT код",
        privacy: "Таны банкны мэдээлэл аюулгүй хадгалагдах бөгөөд зөвхөн төлбөр тооцоонд ашиглагдана",
        submit: "Бүртгүүлэх",
        processing: "Боловсруулж байна..."
      },
      upload: {
        title: "Загвар байршуулах",
        description: "Шинэ загвар оруулах",
        templateTitle: "Загварын гарчиг",
        category: "Ангилал",
        price: "Үнэ (₮)",
        templateDescription: "Тайлбар",
        files: "Файлууд",
        docxFile: "Word файл (DOCX)",
        pdfFile: "PDF файл",
        xlsxFile: "Excel файл (XLSX)",
        previewImage: "Урьдчилсан үзүлтийн зураг",
        optional: "Заавал биш",
        guidelines: "Таны оруулсан загвар манай чанарын шалгуурт нийцэж байгаа эсэхийг шалгах болно. Батлагдсаны дараа таны загвар сайтад харагдах болно.",
        submit: "Илгээх",
        uploading: "Байршуулж байна..."
      }
    },
    admin: {
      submissions: {
        title: "Загварын оруулгууд",
        pending: "Хүлээгдэж буй",
        approved: "Зөвшөөрөгдсөн",
        rejected: "Татгалзсан",
        approve: "Зөвшөөрөх",
        reject: "Татгалзах",
        viewFile: "Файл үзэх"
      },
      templates: {
        goLive: "Нийтлэх",
        goLiveTooltip: "Загварыг сайтад нийтлэх"
      }
    },
    common: {
      loading: "Уншиж байна...",
      error: "Алдаа гарлаа",
      success: "Амжилттай",
      cancel: "Цуцлах",
      save: "Хадгалах",
      saving: "Хадгалж байна...",
      saveChanges: "Өөрчлөлт хадгалах",
      delete: "Устгах",
      edit: "Засах",
      view: "Үзэх",
      back: "Буцах",
      next: "Дараах",
      search: "Хайх",
      filter: "Шүүх",
      noData: "Мэдээлэл олдсонгүй"
    },
    wallet: {
      title: 'Хэтэвч',
      balance: 'Үлдэгдэл',
      available: 'Боломжтой',
      pending: 'Хүлээгдэж буй',
      addCredits: 'Кредит нэмэх',
      topUp: 'Цэнэглэх',
      history: 'Түүх',
      noTransactions: 'Гүйлгээ байхгүй байна',
      totalBalance: 'Нийт үлдэгдэл',
      availableBalance: 'Боломжтой үлдэгдэл',
      pendingReserved: 'Хүлээгдэж буй',
      dailySpend: 'Өнөөдөр зарцуулсан',
      chooseAmount: 'Хэтэвчдээ кредит нэмэх дүнгээ сонгоно уу',
      customAmount: 'Бусад дүн',
      enterAmount: 'Дүн оруулах',
      minAmount: 'Хамгийн бага: 1,000₮ • 1,000₮-ийн нэгжээр',
      promoCode: 'Промо код',
      redeemPromo: 'Промо код ашиглах',
      enterPromoCode: 'Промо код оруулах',
      apply: 'Ашиглах',
      transactionHistory: 'Гүйлгээний түүх',
      date: 'Огноо',
      description: 'Тайлбар',
      amount: 'Дүн',
      type: 'Төрөл',
      downloadCSV: 'CSV татаж авах',
      noHistory: 'Одоогоор гүйлгээ алга',
      spendingForecast: 'Зарцуулалтын төлөв',
      daysRemaining: 'хоног үлдсэн',
      creditsPerDay: 'кредит/өдөр',
      rate: 'Ханш',
      creditsPerMNT: 'кредит 1,000₮ тутамд',
      pleaseLogin: 'Эхлээд нэвтэрнэ үү',
      promoApplied: 'Промо код амжилттай!',
      creditsAdded: 'кредит таны данс дээр нэмэгдлээ',
      invalidPromo: 'Буруу промо код',
      promoError: 'Промо кодыг ашиглах боломжгүй',
      paymentProcessing: 'Төлбөр боловсруулж байна...',
      topUpSuccess: 'Амжилттай цэнэглэлээ!',
      credits: 'кредит',
      lowBalance: 'Үлдэгдэл бага байна',
      topUpNow: 'Одоо цэнэглэх',
      manageCredits: 'Кредит болон гүйлгээгээ удирдах',
      readyToUse: 'Ашиглахад бэлэн',
      reservedForTasks: 'AI хариулт бэлтгэж байна',
      viewTransactions: 'Сүүлийн гүйлгээнүүдийг харах',
      costGuide: 'Кредитийн зардлын гарын авлага',
      understandingCredits: 'Кредит яаж ашиглагддагийг ойлгох',
      chatMessage: 'Чат мессеж',
      basicAIConversation: 'AI ярианы үндсэн хариулт',
      deepResearch: 'Гүн судалгаа',
      webSearchRAG: 'Вэб хайлт + Монгол мэдээлэл',
      imageGeneration: 'Зураг үүсгэх',
      aiGeneratedImage: 'AI үүсгэсэн зураг',
      fileUpload: 'Файл байршуулах',
      documentParsing: 'Баримт боловсруулах',
      advancedFeatures: 'Дэвшилтэт функц',
      complexOperations: 'Нарийн үйлдлүүд',
      varies: 'өөр өөр',
      proTip: 'Зөвлөгөө',
      proTipText: 'Зардал мессежийн урт болон нарийн байдлаас хамаарна. Урт мессежүүд илүү олон токен хэрэглэж илүү кредит зарцуулж болно.',
      freeCredits: 'Өдрийн үнэгүй',
      dailyRenew: 'Өдөр бүр 00:00-д шинэчлэгдэнэ',
      paidBalance: 'Худалдан авсан',
      refresh: 'Шинэчлэх',
      pendingExplanation: 'AI таны хүсэлтийг боловсруулж байх үед түр хадгалсан кредит. Дууссаны дараа чөлөөлөгдөнө.',
      subscription: 'Захиалга',
      currentPlan: 'Одоогийн багц',
      noPlan: 'Идэвхтэй захиалга алга',
      expires: 'Дуусах:',
      active: 'Идэвхтэй',
      days: 'хоног',
      getStarted: 'Эхлэх',
      manageSubscription: 'Захиалга удирдах'
    },
    password: {
      changePassword: 'Нууц үг солих',
      newPassword: 'Шинэ нууц үг',
      confirmPassword: 'Нууц үг баталгаажуулах',
      passwordUpdated: 'Нууц үг шинэчлэгдлээ',
      passwordMismatch: 'Нууц үг таарахгүй байна',
      passwordTooShort: 'Нууц үг дор хаяж 8 тэмдэгт байх ёстой',
      passwordRequirements: 'Том, жижиг үсэг, тоо агуулсан байх ёстой',
      passwordRequirementsDetail: 'Дор хаяж 8 тэмдэгт, том, жижиг үсэг, тоо агуулсан байх ёстой',
      updating: 'Шинэчилж байна...',
      updatePassword: 'Нууц үг шинэчлэх',
      updateDescription: 'Таны дансны нууц үгийг шинэчлэх. Нэвтэрсэн тул шууд шинэ нууц үг тохируулах боломжтой.',
      passwordUpdateSuccess: 'Нууц үг амжилттай солигдлоо! Чиглүүлж байна...',
      passwordLowercase: 'Нууц үг доод үсэг агуулах ёстой',
      passwordUppercase: 'Нууц үг том үсэг агуулах ёстой',
      passwordNumber: 'Нууц үг тоо агуулах ёстой',
      updateFailed: 'Нууц үг шинэчлэхэд алдаа гарлаа',
      confirmNewPassword: 'Шинэ нууц үг баталгаажуулах'
    },
    payment: {
      success: 'Төлбөр амжилттай!',
      creditsAddedCount: 'кредит нэмэгдлээ',
      failed: 'Төлбөр амжилтгүй',
      retry: 'Дахин оролдох',
      addedToWallet: 'кредит таны хэтэвчид нэмэгдлээ'
    },
    resetPassword: {
      validating: 'Токен шалгаж байна...',
      invalidLink: 'Буруу холбоос',
      resetPassword: 'Нууц үг сэргээх',
      enterNewPassword: 'Шинэ нууц үг оруулна уу',
      linkExpired: 'Сэргээх холбоос 30 минутын дотор хүчинтэй',
      requestNewLink: 'Шинэ холбоос авах',
      backToSignIn: 'Нэвтрэх хуудас руу буцах',
      resetting: 'Сэргээж байна...',
      resetAndSignIn: 'Сэргээж нэвтрэх',
      passwordsDontMatch: 'Нууц үг таарахгүй байна',
      passwordMinLength: 'Нууц үг дор хаяж 8 тэмдэгт байх ёстой',
      resetSuccessful: 'Нууц үг амжилттай сэргээгдлээ!',
      nowLoggedIn: 'Та одоо нэвтэрсэн байна',
      resetFailed: 'Алдаа',
      newPassword: 'Шинэ нууц үг',
      confirmPassword: 'Нууц үг баталгаажуулах',
      minLengthHint: 'Дор хаяж 8 тэмдэгт байх ёстой',
      enterForEmail: 'Шинэ нууц үг оруулах'
    },
    settings: {
      title: 'Тохиргоо',
      // Profile tab
      profile: 'Профайл',
      displayName: 'Нэр',
      displayNameDescription: 'Энэ нэр бусад хэрэглэгчдэд харагдана',
      displayNamePlaceholder: 'Нэрээ оруулна уу',
      email: 'И-мэйл',
      emailReadOnly: 'И-мэйл өөрчлөх боломжгүй',
      phone: 'Утасны дугаар',
      phoneOptional: 'Заавал биш',
      profilePhoto: 'Зураг',
      changePhoto: 'Зураг солих',
      uploading: 'Байршуулж байна...',
      photoUpdated: 'Зураг шинэчлэгдлээ',
      photoUpdatedDesc: 'Таны профайл зураг амжилттай шинэчлэгдлээ',
      profileUpdated: 'Профайл шинэчлэгдлээ',
      profileUpdatedDesc: 'Таны профайл амжилттай шинэчлэгдлээ',
      deleteAccount: 'Данс устгах',
      deleteAccountWarning: 'Энэ үйлдлийг буцаах боломжгүй. Таны бүх мэдээлэл бүрмөсөн устгагдана.',
      deleteAccountConfirm: 'Та итгэлтэй байна уу?',
      deleteAccountError: 'Данс устгахад алдаа гарлаа',
      accountDeleted: 'Данс устгагдлаа',
      accountDeletedDesc: 'Таны данс бүрмөсөн устгагдлаа',
      // Language tab
      language: 'Хэл',
      appLanguage: 'Апп-ийн хэл',
      appLanguageDescription: 'Апп-ийн хэрэглэх хэлээ сонгоно уу',
      bilingualAnswers: 'Хоёр хэлээр хариулах',
      bilingualDescription: 'AI хариултыг Монгол + Англи хэлээр харуулах',
      // Security tab
      security: 'Аюулгүй байдал',
      changePassword: 'Нууц үг солих',
      twoFactor: 'Хоёр шатлалт баталгаажуулалт',
      twoFactorDescription: 'Дансдаа нэмэлт хамгаалалт нэмэх',
      comingSoon: 'Удахгүй',
      enable2FA: '2FA идэвхжүүлэх',
      sessionInfo: 'Нэвтрэлтийн мэдээлэл',
      lastLogin: 'Сүүлд нэвтэрсэн',
      device: 'Төхөөрөмж',
      location: 'Байршил',
      noLoginHistory: 'Нэвтрэлтийн түүх алга',
      locationNotAvailable: 'Байршлын мэдээлэл байхгүй',
      // Member info
      memberSince: 'Гишүүнчлэл эхэлсэн',
      accountTier: 'Дансны төрөл',
      tierDescription: 'Таны одоогийн эрхийн түвшин',
      tierFree: 'Үнэгүй',
      tierPaid: 'Төлсөн',
      tierAdmin: 'Админ',
      // Legacy keys
      theme: 'Загвар',
      notifications: 'Мэдэгдэл',
      saveSuccess: 'Тохиргоо хадгалагдлаа',
      examCoach: 'ЭЕШ Бэлтгэл',
      parent: 'Эцэг эх'
    },
    chat: {
      newChat: 'Шинэ чат',
      searchingWeb: 'Вэбээс хайж байна...',
      ragData: 'Монгол мэдээлэл',
      cached: 'Кэш хуулбар',
      webSearch: 'Вэб хайлт',
      gptOnly: 'GPT',
      suggestedQuestions: 'Дараах асуултууд тусална уу:',
      tryWebAgain: 'Вэб дахин хайх',
      enableLiveSearch: 'Шууд хайлт',
      liveSearchEnabled: 'Шууд хайлт идэвхтэй',
      liveSearchDisabled: 'Шууд хайлт идэвхгүй'
    },
    auth: {
      welcome: 'Тавтай морил',
      signIn: 'Нэвтрэх',
      signUp: 'Бүртгүүлэх',
      signInDescription: 'Бүртгэлдээ нэвтрэх эсвэл шинээр үүсгэх',
      email: 'Имэйл',
      password: 'Нууц үг',
      fullName: 'Бүтэн нэр',
      enterEmail: 'Имэйл хаягаа оруулна уу',
      enterPassword: 'Нууц үгээ оруулна уу',
      enterFullName: 'Бүтэн нэрээ оруулна уу',
      signingIn: 'Нэвтэрч байна...',
      creatingAccount: 'Бүртгэж байна...',
      orContinueWith: 'Эсвэл',
      google: 'Google',
      forgotPassword: 'Нууц үгээ мартсан уу?',
      passwordHint: '8+ тэмдэгт, том үсэг, тоо',
      passwordRequirements: 'Нууц үгийн шаардлага',
      atLeast8Chars: 'Хамгийн багадаа 8 тэмдэгт',
      oneUppercase: 'Нэг том үсэг',
      oneLowercase: 'Нэг жижиг үсэг',
      oneNumber: 'Нэг тоо',
      allMet: 'Нууц үг бүх шаардлагыг хангаж байна',
      agreeToTerms: 'Бүртгүүлснээр та Үйлчилгээний нөхцөлийг зөвшөөрч байна',
      backToHome: 'Нүүр хуудас руу буцах',
      or: 'эсвэл',
      continueWithGoogle: 'Google-ээр үргэлжлүүлэх',
      checkEmail: 'Имэйлээ шалгана уу',
      confirmAccount: 'Бүртгэлээ баталгаажуулахын тулд имэйлээ шалгана уу',
      welcomeBack: 'Тавтай морил!',
      signedIn: 'Амжилттай нэвтэрлээ',
      redirectingToGoogle: 'Google руу шилжиж байна...',
      completeGoogleSignIn: 'Google цонхонд нэвтрэлтээ дуусгана уу',
      googleFailed: 'Google нэвтрэлт амжилтгүй',
      error: 'Алдаа',
      forgotPasswordTitle: 'Нууц үгээ мартсан уу?',
      resetYourPassword: 'Нууц үгээ сэргээх',
      enterEmailForReset: 'Имэйлээ оруулсны дараа нууц үг сэргээх холбоос илгээнэ',
      sendResetLink: 'Сэргээх холбоос илгээх',
      sending: 'Илгээж байна...',
      emailRequired: 'Имэйл шаардлагатай',
      enterEmailAddress: 'Имэйл хаягаа оруулна уу',
      checkYourEmail: 'Имэйлээ шалгана уу',
      resetLinkSent: 'Хэрэв бүртгэл байгаа бол нууц үг сэргээх холбоос илгээгдлээ',
      whatsNext: 'Дараагийн алхам',
      checkInbox: 'Lavlah.mn-ээс ирсэн имэйлийг шалгана уу',
      clickResetLink: 'Сэргээх холбоос дээр дарна уу (30 минут хүчинтэй)',
      setNewPassword: 'Шинэ нууц үгээ тохируулна уу',
      didntReceive: "Имэйл ирээгүй юу? Спам хавтсаа шалгаад эсвэл",
      tryAgain: 'дахин оролдох',
      backToSignIn: '← Нэвтрэх хуудас руу буцах',
      subtitle: 'ЭЕШ бэлтгэл & AI туслах',
      verificationSent: 'Баталгаажуулах линк илгээгдлээ',
      checkSpam: 'Имэйл ирээгүй бол спам хавтсаа шалгана уу.',
      verificationCheckInbox: 'хаяг руу баталгаажуулах линк илгээгдлээ. Имэйлээ шалгаад линк дээр дарна уу.',
      completingSignIn: 'Нэвтрэлтийг дуусгаж байна',
      emailSent: 'Имэйл илгээгдлээ',
      resendEmail: 'Дахин илгээх',
      verificationResent: 'Баталгаажуулах имэйл дахин илгээгдлээ',
      verifyYourEmail: 'Имэйл хаягаа баталгаажуулна уу',
      verificationLinkSent: 'хаяг руу баталгаажуулах линк илгээгдсэн.',
      linkMayHaveExpired: 'Баталгаажуулах линк хүчинтэй хугацаа дууссан байж магадгүй.',
      checkEmailThenSignIn: 'Имэйлээ шалгаад линк дээр дарсны дараа нэвтэрнэ үү.',
      pleaseWait: 'Түр хүлээнэ үү...',
      signInSuccessful: 'Амжилттай нэвтэрлээ!',
      redirectingToApp: 'Апп руу шилжиж байна...',
      signInFailed: 'Нэвтрэлт амжилтгүй',
      goToHomepage: 'Нүүр хуудас руу',
      accessDenied: 'Нэвтрэлт цуцлагдсан',
      serverError: 'Серверт алдаа гарлаа',
      temporarilyUnavailable: 'Үйлчилгээ түр ажиллахгүй байна',
      invalidRequest: 'Хүсэлт буруу байна',
      noSession: 'Нэвтрэлтийн мэдээлэл олдсонгүй',
      tryAgainOrContact: 'Дахин оролдох эсвэл тусламж авах',
      invalidCredentials: 'Имэйл эсвэл нууц үг буруу байна',
      emailNotConfirmed: 'Имэйлээ баталгаажуулна уу',
      userExists: 'Энэ имэйлээр бүртгэл аль хэдийн байна',
      weakPassword: 'Нууц үг хэт сул байна',
      rateLimited: 'Хэт олон оролдлого. Түр хүлээнэ үү',
      signupDisabled: 'Бүртгэл түр хаалттай байна',
      accountLocked: 'Данс түр хаагдлаа. 15 минутын дараа дахин оролдоно уу',
      commonPasswordWarning: 'Нийтлэг нууц үг (нэр, 12345678 гм) серверээс цааш хаагдана',
      passwordTooCommon: 'Нууц үг хэт энгийн эсвэл нийтлэг байна. Илүү өвөрмөц нууц үг сонгоно уу.',
      wait: 'Түр хүлээнэ үү',
      quick: 'Хурдан',
      quickAccountWarning: 'Имэйлгүй бүртгэл тул нууц үгээ мартвал сэргээх боломжгүй.',
      repeatPassword: 'Нууц үг давтах',
      quickSignIn: 'Хурдан нэвтрэх',
      attachLater: 'Дараа имэйл эсвэл Google-ээр бүртгэлээ хадгалаарай.',
      agreeIntro: 'Бүртгүүлснээр та',
      terms: 'Үйлчилгээний нөхцөл',
      and: 'болон',
      privacy: 'Нууцлалын бодлого',
      agreeOutro: '-ыг зөвшөөрч байна.',
    },
    adminDashboard: {
      users: 'Хэрэглэгчид',
      revenue: 'Орлого',
      transactions: 'Гүйлгээ',
      wallet: 'Хэтэвч удирдлага',
      credits: 'Кредит үнэлгээ',
      dataEngine: 'Өгөгдлийн хөдөлгүүр',
      ragManagement: 'Мэдээллийн сан',
      systemHealth: 'Системийн эрүүл мэнд',
      creditPricing: 'Кредитийн үнэлгээ'
    }
  },
  en: {
    nav: {
      home: "Home",
      jobs: "Jobs",
      templates: "Templates",
      browseTemplates: "Browse Templates",
      about: "About",
      contact: "Contact",
      mainSite: "Main Site",
      aiChat: "AI Chat",
      examCoach: "Exam Coach",
      geeProgress: "GEE Progress",
    },
    seller: {
      dashboard: {
        title: "Seller Dashboard",
        welcome: "Welcome back",
        uploadTemplate: "Upload New Template",
        salesLast30Days: "Sales (Last 30 Days)",
        availableBalance: "Available Balance",
        pendingPayouts: "Pending Payouts",
        totalSales: "Total Sales",
        recentOrders: "Recent Orders",
        noOrders: "No orders yet",
        paid: "Paid",
        unpaid: "Unpaid",
        requestWithdrawal: "Request Withdrawal"
      },
      onboard: {
        title: "Become a Seller",
        description: "Enter the following information to start selling your templates",
        displayName: "Display Name",
        displayNameHint: "This name will be shown on your templates",
        bankInfo: "Bank Information",
        bankName: "Bank Name",
        accountHolder: "Account Holder Name",
        accountNumber: "Account Number",
        swiftCode: "SWIFT Code",
        privacy: "Your bank information is stored securely and only used for payouts",
        submit: "Register",
        processing: "Processing..."
      },
      upload: {
        title: "Upload Template",
        description: "Submit a new template",
        templateTitle: "Template Title",
        category: "Category",
        price: "Price (₮)",
        templateDescription: "Description",
        files: "Files",
        docxFile: "Word File (DOCX)",
        pdfFile: "PDF File",
        xlsxFile: "Excel File (XLSX)",
        previewImage: "Preview Image",
        optional: "Optional",
        guidelines: "Your submission will be reviewed for quality. Once approved, it will be available on the site.",
        submit: "Submit",
        uploading: "Uploading..."
      }
    },
    admin: {
      submissions: {
        title: "Template Submissions",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        approve: "Approve",
        reject: "Reject",
        viewFile: "View File"
      },
      templates: {
        goLive: "Go Live",
        goLiveTooltip: "Publish template to site"
      }
    },
    common: {
      loading: "Loading...",
      error: "Error occurred",
      success: "Success",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving...",
      saveChanges: "Save Changes",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      back: "Back",
      next: "Next",
      search: "Search",
      filter: "Filter",
      noData: "No data found"
    },
    wallet: {
      title: 'Wallet',
      balance: 'Balance',
      available: 'Available',
      pending: 'Pending',
      addCredits: 'Add Credits',
      topUp: 'Top Up',
      history: 'History',
      noTransactions: 'No transactions',
      totalBalance: 'Total Balance',
      availableBalance: 'Available Balance',
      pendingReserved: 'Pending',
      dailySpend: 'Spent Today',
      chooseAmount: 'Choose an amount to add credits to your wallet',
      customAmount: 'Custom',
      enterAmount: 'Enter amount',
      minAmount: 'Minimum: 1,000₮ • Increments of 1,000₮',
      promoCode: 'Promo Code',
      redeemPromo: 'Redeem Promo Code',
      enterPromoCode: 'Enter promo code',
      apply: 'Apply',
      transactionHistory: 'Transaction History',
      date: 'Date',
      description: 'Description',
      amount: 'Amount',
      type: 'Type',
      downloadCSV: 'Download CSV',
      noHistory: 'No transactions yet',
      spendingForecast: 'Spending Forecast',
      daysRemaining: 'days remaining',
      creditsPerDay: 'credits/day',
      rate: 'Rate',
      creditsPerMNT: 'credits per 1,000₮',
      pleaseLogin: 'Please login first',
      promoApplied: 'Promo code applied successfully!',
      creditsAdded: 'credits added to your account',
      invalidPromo: 'Invalid promo code',
      promoError: 'Unable to apply promo code',
      paymentProcessing: 'Processing payment...',
      topUpSuccess: 'Top-up successful!',
      credits: 'credits',
      lowBalance: 'Low balance',
      topUpNow: 'Top up now',
      manageCredits: 'Manage your credits and transactions',
      readyToUse: 'Ready to use',
      reservedForTasks: 'Processing AI response',
      viewTransactions: 'View your recent credit transactions',
      costGuide: 'Credit Cost Guide',
      understandingCredits: 'Understanding how credits are used',
      chatMessage: 'Chat Message',
      basicAIConversation: 'Basic AI conversation',
      deepResearch: 'Deep Research',
      webSearchRAG: 'Web search + local data',
      imageGeneration: 'Image Generation',
      aiGeneratedImage: 'AI-generated image',
      fileUpload: 'File Upload',
      documentParsing: 'Document parsing',
      advancedFeatures: 'Advanced Features',
      complexOperations: 'Complex operations',
      varies: 'varies',
      proTip: 'Pro tip',
      proTipText: 'Costs vary based on message length and complexity. Longer messages use more tokens and may cost more credits.',
      freeCredits: 'Daily Free',
      dailyRenew: 'Renews daily at 00:00',
      paidBalance: 'Paid Balance',
      refresh: 'Refresh',
      pendingExplanation: 'Credits temporarily held while AI processes your request. Released after completion.',
      subscription: 'Subscription',
      currentPlan: 'Current Plan',
      noPlan: 'No active subscription',
      expires: 'Expires:',
      active: 'Active',
      days: 'days',
      getStarted: 'Get Started',
      manageSubscription: 'Manage Subscription'
    },
    password: {
      changePassword: 'Change Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      passwordUpdated: 'Password Updated',
      passwordMismatch: 'New passwords do not match',
      passwordTooShort: 'Password must be at least 8 characters long',
      passwordRequirements: 'Must contain uppercase, lowercase, and numbers',
      passwordRequirementsDetail: 'Must be at least 8 characters with uppercase, lowercase, and numbers',
      updating: 'Updating...',
      updatePassword: 'Update Password',
      updateDescription: 'Update your account password. Since you\'re already logged in, you can set a new password directly.',
      passwordUpdateSuccess: 'Password updated successfully! Redirecting...',
      passwordLowercase: 'Password must contain at least one lowercase letter',
      passwordUppercase: 'Password must contain at least one uppercase letter',
      passwordNumber: 'Password must contain at least one number',
      updateFailed: 'Failed to update password',
      confirmNewPassword: 'Confirm New Password'
    },
    payment: {
      success: 'Payment Successful!',
      creditsAddedCount: 'credits have been added to your wallet',
      failed: 'Payment Failed',
      retry: 'Retry',
      addedToWallet: 'credits have been added to your wallet'
    },
    resetPassword: {
      validating: 'Validating reset token...',
      invalidLink: 'Invalid Reset Link',
      resetPassword: 'Reset Your Password',
      enterNewPassword: 'Enter a new password for',
      linkExpired: 'Reset links are only valid for 30 minutes.',
      requestNewLink: 'Request new link',
      backToSignIn: 'Back to sign in',
      resetting: 'Resetting...',
      resetAndSignIn: 'Reset & sign in',
      passwordsDontMatch: 'Passwords don\'t match',
      passwordMinLength: 'Password must be at least 8 characters',
      resetSuccessful: 'Password reset successful!',
      nowLoggedIn: 'You\'re now logged in',
      resetFailed: 'Error',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      minLengthHint: 'Must be at least 8 characters',
      enterForEmail: 'Enter a new password for'
    },
    settings: {
      title: 'Settings',
      // Profile tab
      profile: 'Profile',
      displayName: 'Display Name',
      displayNameDescription: 'This name will be visible to other users',
      displayNamePlaceholder: 'Enter your name',
      email: 'Email',
      emailReadOnly: 'Email cannot be changed',
      phone: 'Phone Number',
      phoneOptional: 'Optional',
      profilePhoto: 'Profile Photo',
      changePhoto: 'Change Photo',
      uploading: 'Uploading...',
      photoUpdated: 'Photo updated',
      photoUpdatedDesc: 'Your profile photo has been updated successfully',
      profileUpdated: 'Profile updated',
      profileUpdatedDesc: 'Your profile has been updated successfully',
      deleteAccount: 'Delete Account',
      deleteAccountWarning: 'This action cannot be undone. This will permanently delete your account and remove all your data.',
      deleteAccountConfirm: 'Are you absolutely sure?',
      deleteAccountError: 'Failed to delete account',
      accountDeleted: 'Account deleted',
      accountDeletedDesc: 'Your account has been permanently deleted',
      // Language tab
      language: 'Language',
      appLanguage: 'App Language',
      appLanguageDescription: 'Choose your preferred language for the app interface',
      bilingualAnswers: 'Show Bilingual Answers',
      bilingualDescription: 'Display AI responses in both Mongolian and English',
      // Security tab
      security: 'Security',
      changePassword: 'Change Password',
      twoFactor: 'Two-Factor Authentication',
      twoFactorDescription: 'Add an extra layer of security to your account',
      comingSoon: 'Coming Soon',
      enable2FA: 'Enable 2FA',
      sessionInfo: 'Session Information',
      lastLogin: 'Last Login',
      device: 'Device',
      location: 'Location',
      noLoginHistory: 'No login history available',
      locationNotAvailable: 'Location data not available',
      // Member info
      memberSince: 'Member Since',
      accountTier: 'Account Tier',
      tierDescription: 'Your current subscription tier',
      tierFree: 'Free',
      tierPaid: 'Paid',
      tierAdmin: 'Admin',
      // Legacy keys
      theme: 'Theme',
      notifications: 'Notifications',
      saveSuccess: 'Settings saved',
      examCoach: 'Mongolian General Entrance Examination (GEE)',
      parent: 'Parent'
    },
    chat: {
      newChat: 'New Chat',
      searchingWeb: 'Searching web...',
      ragData: 'Lavlah.mn data',
      cached: 'Cached',
      webSearch: 'Web search',
      gptOnly: 'GPT',
      suggestedQuestions: 'Try these questions:',
      tryWebAgain: '🔁 Retry web search',
      enableLiveSearch: '🔍 Live Search',
      liveSearchEnabled: 'Live search enabled',
      liveSearchDisabled: 'Live search disabled'
    },
    auth: {
      welcome: 'Welcome',
      signIn: 'Sign In',
      signUp: 'Sign Up',
      signInDescription: 'Sign in to your account or create a new one',
      email: 'Email',
      password: 'Password',
      fullName: 'Full Name',
      enterEmail: 'Enter your email',
      enterPassword: 'Enter your password',
      enterFullName: 'Enter your full name',
      signingIn: 'Signing in...',
      creatingAccount: 'Creating account...',
      orContinueWith: 'Or continue with',
      google: 'Google',
      forgotPassword: 'Forgot your password?',
      passwordHint: 'Min. 8 chars, 1 uppercase, 1 number',
      passwordRequirements: 'Password requirements',
      atLeast8Chars: 'At least 8 characters',
      oneUppercase: 'One uppercase letter',
      oneLowercase: 'One lowercase letter',
      oneNumber: 'One number',
      allMet: 'Password meets all requirements',
      agreeToTerms: 'By signing up, you agree to our Terms of Service',
      backToHome: 'Back to homepage',
      or: 'or',
      continueWithGoogle: 'Continue with Google',
      checkEmail: 'Check your email',
      confirmAccount: 'Check your email to confirm your account',
      welcomeBack: 'Welcome back!',
      signedIn: 'You have successfully signed in',
      redirectingToGoogle: 'Redirecting to Google...',
      completeGoogleSignIn: 'Please complete sign-in in the Google window',
      googleFailed: 'Google Sign-in Failed',
      error: 'Error',
      forgotPasswordTitle: 'Forgot your password?',
      resetYourPassword: 'Reset your password',
      enterEmailForReset: "Enter your email and we'll send you a link to reset your password",
      sendResetLink: 'Send reset link',
      sending: 'Sending...',
      emailRequired: 'Email required',
      enterEmailAddress: 'Please enter your email address',
      checkYourEmail: 'Check Your Email',
      resetLinkSent: "If an account exists, you'll receive a password reset link",
      whatsNext: "What's next?",
      checkInbox: 'Check your inbox for an email from Lavlah.mn',
      clickResetLink: 'Click the reset link (valid for 30 minutes)',
      setNewPassword: 'Set your new password',
      didntReceive: "Didn't receive the email? Check your spam folder or",
      tryAgain: 'try again',
      backToSignIn: '← Back to sign in',
      subtitle: 'Exam Prep & AI Assistant',
      verificationSent: 'A verification link has been sent',
      checkSpam: "Check your spam folder if you don't see the email.",
      verificationCheckInbox: 'Please check your inbox and click the link to activate your account.',
      completingSignIn: 'Completing Sign-In',
      emailSent: 'Email sent',
      resendEmail: 'Resend email',
      verificationResent: 'Verification email has been resent',
      verifyYourEmail: 'Please verify your email',
      verificationLinkSent: 'A verification link was sent to your email.',
      linkMayHaveExpired: 'Your verification link may have expired.',
      checkEmailThenSignIn: 'Please check your email and click the link before signing in.',
      pleaseWait: 'Please wait while we authenticate your account...',
      signInSuccessful: 'Sign-In Successful!',
      redirectingToApp: 'Redirecting you to the app...',
      signInFailed: 'Sign-In Failed',
      goToHomepage: 'Go to Homepage',
      accessDenied: 'Access was denied during sign-in',
      serverError: 'A server error occurred during authentication',
      temporarilyUnavailable: 'The authentication service is temporarily unavailable',
      invalidRequest: 'The authentication request was invalid',
      noSession: 'No authentication data was received',
      tryAgainOrContact: 'Please try again or contact support',
      invalidCredentials: 'Incorrect email or password',
      emailNotConfirmed: 'Please check your email to verify your account',
      userExists: 'An account with this email already exists',
      weakPassword: 'Password is too weak',
      rateLimited: 'Too many attempts. Please try again later',
      signupDisabled: 'Registration is currently disabled. Please contact support',
      accountLocked: 'Account temporarily locked. Too many failed login attempts. Please try again in 15 minutes',
      commonPasswordWarning: 'Common passwords (names, 12345678 etc.) will be rejected by the server',
      passwordTooCommon: 'Password is too common or easy to guess. Please choose a more unique password.',
      wait: 'Please wait',
      quick: 'Quick',
      quickAccountWarning: 'This account has no email, so a forgotten password cannot be recovered.',
      repeatPassword: 'Repeat password',
      quickSignIn: 'Quick sign in',
      attachLater: 'You can attach an email or Google account later.',
      agreeIntro: 'By signing up, you agree to our',
      terms: 'Terms of Service',
      and: 'and',
      privacy: 'Privacy Policy',
      agreeOutro: '.',
    },
    adminDashboard: {
      users: 'Users',
      revenue: 'Revenue',
      transactions: 'Transactions',
      wallet: 'Wallet Management',
      credits: 'Credit Pricing',
      dataEngine: 'Data Engine',
      ragManagement: 'RAG Management',
      systemHealth: 'System Health',
      creditPricing: 'Credit Pricing'
    }
  }
};

export type Language = keyof typeof translations;
export type TranslationKeys = typeof translations.en;

export function t(lang: Language, path: string): string {
  const keys = path.split('.');
  let value: any = translations[lang];
  
  for (const key of keys) {
    value = value?.[key];
  }
  
  return value || path;
}